export default __webpack_public_path__ + "static/banner-9fd5d21300ab65677ec71d9a142179f0.png";